import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import moment from 'moment';

/* Function */
import { Tooltip } from 'react-bootstrap';
import $ from 'jquery';
import { Circle, Map, TileLayer } from 'react-leaflet-universal';
import ObjGeneral from '../function';
/* Local store */
import { localStoreFN } from '../../store/localStorage';

/* Actions */
import * as assignmentListActions from '../../actions/assignment_list/index';
import * as accountDriverActions from '../../actions/account_driver/index.js';

/* Components */
import Header from '../../components/assignment_list/header';
import Title from '../../components/assignment_list/title';
import TitleSecond from '../../components/assignment_list/titleSecond';
import Table from '../../components/assignment_list/table';
import Graph from '../../components/assignment_list/graph';
import ModalMap from '../../components/assignment_list/modalMap';
import Buttons from '../../components/assignment_list/buttons';
import ModalConection from '../../components/assignment_list/modalConection';
import Expired from '../expired/index';

import Loading from '../../components/common/loading';
import Message from '../../components/common/message';

class AssignmentList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        selectDriver: null,
        selectVehicle: null
      },
      filterName: {
        selectDriver: null,
        selectVehicle: null
      },
      input: {
        selectDriver: '',
        selectVehicle: ''
      },
      show: false
    };
  }

  async componentDidMount() {
    // get the permissions to validate the view
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('assignment');
    if (permit) {
      if (this.props.setting) {
        //  this.setState({ showMap: true });
        // get the setting objects
        const obj = JSON.parse(this.props.setting.value);
        if (obj.generalSetting.views.includes('assignment')) {
          await this.props.actions.fetchAssignmentApi({});
          await this.props.actions.fetchAssignmentListApi({});
          await this.props.accountDriverActions.fetchAccountDriverApi({
            seeFilter: true
          });
        } else {
          // not authorized
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      // not authorized
      this.props.history.push('/dashboard/authorization');
    }
  }

  componentDidUpdate(prevProps, prevState) {}

  // function in charge of filtering
  handleFilter = async event => {
    const select = event.target.dataset.select;
    const name = event.target.dataset.name;
    const parent = event.target.dataset.parent;
    const special = event.target.dataset.special;

    if (special) {
      document.getElementById(parent).innerHTML = `${special}: ${event.target.innerHTML}`;
    } else {
      document.getElementById(parent).innerHTML = `${
        this.props.language.summary.filter[event.target.dataset.parent]
      }: ${event.target.innerHTML}`;
    }

    const filter = Object.assign({}, this.state.filter);
    filter[event.target.dataset.parent] = select;

    /* Set sort */
    this.setState({
      filter
    });

    const fil = Object.assign({}, this.state.filterName);
    fil[parent] = name;

    /* Set sort */
    this.setState({
      fil
    });

    /* TAGS */
    const tags = ObjGeneral.getTags({});
  };

  handleSubmit = async obj => {
    /* TAGS */
    const tags = ObjGeneral.getTags(obj);
    await this.props.actions.fetchAssignmentApi({ tags });
  };

  handleChange = e => {
    const input = { ...this.state.input };
    input[e.target.dataset.update] = e.target.value;
    this.setState({
      input
    });
  };

  handleChangeReset = () => {
    this.setState({
      input: {
        selectDriver: '',
        selectVehicle: ''
      }
    });
  };

  handlePropagation = e => {
    e.stopPropagation();
  };

  handleModal = e => {
    this.setState({ show: !this.state.show });
    $(window)
      .on('load resize', () => {
        const scrollWidth = $('.tbl-content').width() - $('.tbl-content table').width();
        $('.tbl-header').css({ 'padding-right': scrollWidth });
      })
      .resize();
  };

  handleMOuseOver = event => {
    const nodeel = document.getElementById('mapp');

    if (nodeel != null) {
      nodeel.parentNode.innerHTML = '';
    }
    const element = event.target.nextSibling;

    let L;
    L = require('leaflet');
    require('leaflet-draw');
    const center = [17.385044, 78.486671];

    element.innerHTML = `
    <div>
      <h2>Lugar de conexión</h2>
      <p>
      <span>Conductor:</span>
      <span>Jorge Felipe Quiroz,</span>
      <span>Vehículo:</span>
      <span>HGBF32,</span>
      <span>Fecha assignación:</span>
      <span>20/20/2019,</span>
      <span>15h:30m</span>
      </p>
      <div id='mapp-wraper'>
        <div id="mapp"></div>
      </div>
      <i></i>
    </div>`;

    const map = L.map('mapp').setView(center, 16);

    // Set up the OSM layer
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: 'Data © <a href="http://osm.org/copyright">OpenStreetMap</a>',
      maxZoom: 18
    }).addTo(map);

    const circleCenter = [17.385044, 78.486671]; // Center of the circle
    // Circle options
    const circleOptions = {
      color: 'red',
      fillColor: '#f03',
      fillOpacity: 1,
      radius: 5
    };

    // Creating a circle
    const circle = L.circle(circleCenter, circleOptions);
    circle.addTo(map); // Adding circle to the map
  };

  render() {
    // the setting object is obtained which we use for the configuration
    const obj = JSON.parse(this.props.setting.value);

    const setting = ObjGeneral.getSetting({
      setting: obj.summaryNFA,
      filter: this.props.filter,
      general: obj.generalSetting
    });

    // condition done to see if the setting was done
    if (this.props.setting) {
      const header = (
        <Header
          main={this.state.select}
          handleSubmit={this.handleSubmit}
          language={this.props.language}
          filter={setting.filter}
          filters={this.props.filters}
        />
      );
      let container = '';
      // condition performed for loading state of the view
      if (this.props.loading || this.props.accountDriverLoading) {
        container = <Loading language={this.props.language} />;
        // the application statusFilter 401 Expired token or unauthorized
      } else if (
        this.props.status === 401 ||
        this.props.statusTags === 401 ||
        this.props.accountDriverStatus === 401 ||
        this.props.statusFilter === 401
      ) {
        container = <Expired history={this.props.history} />;
        // the statusFilter 200 of the success application
      } else if (
        this.props.status === 200 &&
        this.props.statusTags === 200 &&
        this.props.accountDriverStatus === 200 &&
        this.props.statusFilter === 200
      ) {
        container = (
          <div className="main-container">
            <Title language={this.props.language} />
            <Buttons
              vehicles={this.props.datos}
              drivers={this.props.accountDriverDatos}
              handleChangeReset={this.handleChangeReset}
              handleChange={this.handleChange}
              handleFilter={this.handleFilter}
              language={this.props.language}
              input={this.state.input}
              filter={this.state.filterName}
              handleModal={this.handleModal}
            />
            <Table
              datos={this.props.datos}
              handleMOuseOver={this.handleMOuseOver}
              handleMOuseLeave={this.handleMOuseLeave}
              language={this.props.language}
            >
              <ModalMap />
            </Table>
            <TitleSecond />
            <Graph language="Test" setting={obj} data={this.props.datosFilter} id="test1" />
            <Tooltip placement="top" id="pageTooltip" />
            <ModalConection
              isHide={this.state.show}
              handlePropagation={this.handlePropagation}
              handleModal={this.handleModal}
              language={this.props.language}
              datos={this.props.datos}
            />
          </div>
        );
      } else if (
        this.props.status === 500 ||
        this.props.statusTags === 500 ||
        this.props.accountDriverStatus === 500 ||
        this.props.statusFilter === 500
      ) {
        container = <Message message={this.props.language.error.apiError500} />;
      } else {
        container = <Message message={this.props.language.error.apiError} />;
      }
      return (
        <section className="main" onScroll={this.handleScroll}>
          {header}
          {container}
        </section>
      );
    }

    return (
      <section className="main">
        <Message message="NO Setting" />
      </section>
    );
  }
}

const mapStateToProps = state => ({
  accountDriverDatos: state.reducer.accountDriver.datos,
  accountDriverStatus: state.reducer.accountDriver.status,
  accountDriverLoading: state.reducer.accountDriver.loading,

  filter: state.reducer.tags.filter,
  statusTags: state.reducer.tags.status,

  setting: state.reducer.dashboard.setting,
  language: state.reducer.dashboard.language,

  loading: state.reducer.assignmentList.loading,
  datos: state.reducer.assignmentList.datos,
  status: state.reducer.assignmentList.status,

  loadingFilter: state.reducer.assignmentList.loadingFilter,
  datosFilter: state.reducer.assignmentList.datosFilter,
  statusFilter: state.reducer.assignmentList.statusFilter
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(assignmentListActions, dispatch),
  accountDriverActions: bindActionCreators(accountDriverActions, dispatch)
});

AssignmentList.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssignmentList);



// WEBPACK FOOTER //
// ./source/client/containers/assignment_list/index.jsx